<template>
	<div class="PercentFromCenterBar">
		<div class="PercentFromCenterBar__left">
			<div
				class="PercentFromCenterBar__inner"
				v-bind:style='getStylesFor("left")'
			></div>
			<div
				v-if="showDiffToMiddle"
				class="PercentFromCenterBar__label text-left"
				v-bind:style='getLabelPosition("left")'
			>
				{{ diffToMiddle }}
				{{ valueUnit() }}
			</div>
		</div>
		<div class="PercentFromCenterBar__middle"></div>
		<div class="PercentFromCenterBar__right">
			<div
				class="PercentFromCenterBar__inner"
				v-bind:style='getStylesFor("right")'
			></div>
			<div
				v-if="showDiffToMiddle"
				class="PercentFromCenterBar__label text-right"
				v-bind:style='getLabelPosition("right")'
			>
				{{ diffToMiddle }}
				{{ valueUnit() }}
			</div>
		</div>
	</div>
</template>

<script>
import { percentOfValueInRange } from "../../utils";

export default {
	name: "percent-from-center-bar",
	props: {
		min: Number,
		srvMiddle: Number,
		max: Number,
		value: Number,
		valueUnits: Object,
		backgroundColors: {
			type: Array,
			default: function () {
				return [
					"#BB0000",
					"#BB2900",
					"#BB5300",
					"#BB7C00",
					"#BBA600",
					"#A6BB00",
					"#7CBB00",
					"#53BB00",
					"#29BB00",
					"#00BB00",
				];
			},
		},
		barId: String,
		increaseIsDesirable: {
			type: Boolean,
			default: true,
		},
		showDiffToMiddle: Boolean,
	},
	computed: {
		middle() {
			// `this.srvMiddle || otherValue` will return "otherValue" if "srvMiddle" is 0 because JS
			return this.srvMiddle !== undefined
				? this.srvMiddle
				: (this.min + this.max) / 2;
		},
		diffToMiddle() {
			const valueOffset = this.value - this.middle;
			return `${this.value == this.middle ? "±" : this.value > this.middle ? "+" : ""}${Math.round(valueOffset * 100) / 100}`; // Round to 2 decimal places
		},
		computedStyles() {
			const colorSliceIndex = Math.ceil(this.backgroundColors.length / 2);
			let minForRange;
			let maxForRange;
			// Need to duplicate array, `reverse` writes its output to original variable
			let workingColorArray = this.increaseIsDesirable
				? this.backgroundColors
				: [...this.backgroundColors].reverse();
			if (this.value < this.middle) {
				maxForRange = this.min;
				minForRange = this.middle;
				workingColorArray = workingColorArray.slice(0, colorSliceIndex);
			} else {
				minForRange = this.middle;
				maxForRange = this.max;
				workingColorArray = workingColorArray.slice(colorSliceIndex);
			}
			let percentOfRange = percentOfValueInRange(
				this.value,
				minForRange,
				maxForRange,
			);
			if (percentOfRange > 100) {
				percentOfRange = 100;
			}
			const colorIndex = Math.round(
				(percentOfRange * (workingColorArray.length - 1)) / 100,
			);
			return {
				width: `${percentOfRange}%`,
				backgroundColor: workingColorArray[colorIndex],
			};
		},
		increaseDirection() {
			return I18n.t("meta.direction") == "rtl" ? "left" : "right";
		},
		decreaseDirection() {
			return I18n.t("meta.direction") == "rtl" ? "right" : "left";
		},
	},
	mounted() {
		pp.vue.bus.$on("percent-bar-value-CHANGE", (argHash) => {
			if (
				(this.barId === undefined && argHash.bar_id === undefined) ||
				this.barId == argHash.bar_id
			) {
				// @ts-expect-error
				this.value = argHash.value;
			}
		});
	},
	beforeDestroy() {
		pp.vue.bus.$off("percent-bar-value-CHANGED");
	},
	methods: {
		getStylesFor(direction) {
			const isDecrease =
				direction === this.decreaseDirection && this.value < this.middle;
			const isIncrease =
				direction === this.increaseDirection && this.value >= this.middle;
			if (isDecrease || isIncrease) {
				return this.computedStyles;
			}
			// else
			return { width: "0%" };
		},

		getLabelPosition(direction) {
			const isDecrease =
				direction === this.decreaseDirection && this.value < this.middle;
			const isIncrease =
				direction === this.increaseDirection && this.value >= this.middle;
			if (isDecrease || isIncrease) {
				return { width: this.computedStyles.width };
			}
			// else
			return { display: "none" };
		},

		valueUnit() {
			if (this.valueUnits !== undefined) {
				let value =
					this.valueUnits[I18n.locale] ||
					Object.values(this.valueUnits)[0] ||
					"";
				if (value.length > 1) {
					value = " " + value;
				}
				return value;
			}
			// else
			return "";
		},
	},
};
</script>
